import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      // Navigation
      dashboard: 'Dashboard',
      surveys: 'Surveys',
      plants: 'Plants',
      reports: 'Reports',
      settings: 'Settings',
      logout: 'Logout',
      createSurvey: 'Create Survey',
      
      // Authentication
      login: 'Login',
      username: 'Username',
      password: 'Password',
      loginButton: 'Login',
      loginError: 'Invalid username or password',
      
      // Dashboard
      welcomeMessage: 'Welcome to Seed Management System',
      totalSurveys: 'Total Surveys',
      totalParticipants: 'Total Participants',
      totalCrops: 'Total Crops',
      recentSurveys: 'Recent Surveys',
      surveysByGovernorate: 'Surveys by Governorate',
      surveysByCrop: 'Surveys by Crop',
      noSurveysFound: 'No surveys found',
      
      // Survey Form
      surveyForm: 'Survey Form',
      step: 'Step',
      of: 'of',
      
      // Form fields
      surveyNumber: 'Survey Number',
      surveyNumberAutoGenerated: 'Survey number will be auto-generated',
      participant: 'Participant',
      farmer: 'Farmer',
      governorate: 'Governorate',
      state: 'State',
      village: 'Village',
      latitude: 'Latitude',
      longitude: 'Longitude',
      getCurrentLocation: 'Get Current Location',
      gettingLocation: 'Getting Location...',
      geolocationNotSupported: 'Geolocation is not supported by this browser',
      errorGettingLocation: 'Error getting location. Please try again.',
      crop: 'Crop',
      usage: 'Usage',
      variety: 'Variety',
      varietyNumber: 'Variety Number',
      localName: 'Local Name',
      sampleType: 'Sample Type',
      geneticStatus: 'Genetic Status',
      collectionDate: 'Collection Date',
      notes: 'Notes',
      hasHerbariumSample: 'Has Herbarium Sample',
      
      // Form sections
      basicInfo: 'Basic Information',
      basicInfoAndParticipants: 'Basic Information and Participants',
      basicInfoAndParticipantsDesc: 'Enter basic survey information and manage participants',
      surveyBasicInfoAndParticipants: 'Survey basic information and participants management',
      farmerAndLocation: 'Farmer and Location Information',
      farmerAndLocationDesc: 'Enter farmer details and location information',
      farmerLocationInfo: 'Farmer details and geographical location information',
      cropSampleAndSettings: 'Crop, Sample and Settings',
      cropSampleAndSettingsDesc: 'Enter crop details, sample information and additional settings',
      cropSampleSettingsInfo: 'Crop details, sample information and additional settings',
      farmerAndParticipants: 'Farmer and Participants',
      farmerInfo: 'Farmer Information',
      locationInfo: 'Location Information',
      coordinatesAndDetails: 'Coordinates and Additional Details',
      cropInfo: 'Crop Information',
      sampleInfo: 'Sample Information',
      coordinates: 'Coordinates',
      additionalLocationInfo: 'Additional Location Information',
      manualLatitude: 'Manual Latitude',
      manualLongitude: 'Manual Longitude',
      elevation: 'Elevation',
      elevationPlaceholder: 'Enter elevation in meters',
      locationDescription: 'Location Description',
      locationDescriptionPlaceholder: 'Describe the location details...',
      cropAge: 'Crop Age',
      cropAgePlaceholder: 'e.g., 3 months, 1 year',
      
      // Form validation
      pleaseSelect: 'Please Select',
      enterValue: 'Enter value',
      optional: 'Optional',
      required: 'Required',
      invalidEmail: 'Invalid email address',
      invalidPhone: 'Invalid phone number',
      invalidDate: 'Invalid date format',
      
      // Validation messages for survey form
      dateCollectedRequired: 'Collection date is required',
      atLeastOneParticipantRequired: 'At least one participant is required',
      farmerNameRequired: 'Farmer name is required',
      farmerPhoneRequired: 'Farmer phone is required',
      governorateRequired: 'Governorate is required',
      stateRequired: 'State is required',
      villageRequired: 'Village is required',
      
      // Location search texts
      searchOrSelectGovernorate: 'Search or select governorate',
      searchOrSelectState: 'Search or select state',
      searchOrSelectVillage: 'Search or select village',
      selectGovernorateFirst: 'Please select governorate first',
      selectStateFirst: 'Please select state first',
      noGovernoratesFound: 'No governorates found',
      noStatesFound: 'No states found',
      noVillagesFound: 'No villages found',
      
      // Map Picker translations (new keys only)
      selectLocationFromMap: 'Select Location from Map',
      clickOnMapToSelectLocation: 'Click on the map to select a location',
      selectedCoordinates: 'Selected Coordinates',
      manualEntry: 'Manual Entry',
      mapSelection: 'Map Selection',
      searchLocation: 'Search for a location...',
      searching: 'Searching...',
      currentLocation: 'Current Location',
      zoomIn: 'Zoom In',
      zoomOut: 'Zoom Out',
      
      locationRequired: 'Location coordinates are required',
      cropRequired: 'Crop is required',
      varietyNumberRequired: 'Variety number is required',
      localNameRequired: 'Local name is required',
      cropAgeRequired: 'Crop age is required',
      usageRequired: 'At least one usage is required',
      sampleTypeRequired: 'Sample type is required',
      geneticStatusRequired: 'Genetic status is required',
      collectionSourceRequired: 'Collection source is required',
      materialRequired: 'Material is required',
      topographyRequired: 'Topography is required',
      locationStatusRequired: 'Location status is required',
      soilTextureRequired: 'Soil texture is required',
      soilColorRequired: 'Soil color is required',
      hardnessRequired: 'Hardness is required',
      drainageRequired: 'Drainage is required',
      soilPhRequired: 'Soil pH is required',
      waterPhRequired: 'Water pH is required',
      
      // Actions
      next: 'Next',
      back: 'Back',
      previous: 'Previous',
      submit: 'Submit',
      cancel: 'Cancel',
      save: 'Save',
      edit: 'Edit',
      delete: 'Delete',
      confirm: 'Confirm',
      view: 'View',
      viewDetails: 'View Details',
      search: 'Search',
      filter: 'Filter',
      export: 'Export',
      add: 'Add',
      create: 'Create',
      finish: 'Finish',
      
      // Common Field Names
      name: 'Name',
      surveysCount: 'Surveys Count',
      
      // Status
      loading: 'Loading...',
      saving: 'Saving...',
      success: 'Success',
      error: 'Error',
      warning: 'Warning',
      info: 'Information',
      
      // Messages
      saveSuccess: 'Data saved successfully',
      saveError: 'Error saving data',
      deleteSuccess: 'Data deleted successfully',
      deleteError: 'Error deleting data',
      loadError: 'Error loading data',
      
      // Common
      yes: 'Yes',
      no: 'No',
      noData: 'No data available',
      selectOption: 'Select an option',
      
      // Survey Details Page Sections
      surveyInformation: 'Survey Information',
      locationInformation: 'Location Information',
      cropInformation: 'Crop Information',
      sampleInformation: 'Sample Information',
      topographyInformation: 'Topography Information',
      photos: 'Photos',
      additionalInformation: 'Additional Information',
      createdBy: 'Created By',
      createdAt: 'Created At',
      
      // Plant List
      plantList: 'Plant List',
      scientificName: 'Scientific Name',
      commonName: 'Common Name',
      family: 'Family',
      
      // Languages
      arabic: 'العربية',
      english: 'English',
      language: 'Language',
      
      // Farmers Management
      farmers: 'Farmers',
      farmersManagement: 'Farmers Management',
      farmersPageTitle: 'Farmers Management',
      farmersPageDescription: 'Manage and track all registered farmers in the system',
      addFarmer: 'Add Farmer',
      editFarmer: 'Edit Farmer',
      deleteFarmer: 'Delete Farmer',
      farmerDetails: 'Farmer Details',
      totalFarmers: 'Total Farmers',
      searchFarmers: 'Search farmers by name, civil ID or phone',
      farmerAddedSuccessfully: 'Farmer added successfully',
      farmerUpdatedSuccessfully: 'Farmer updated successfully',
      farmerDeletedSuccessfully: 'Farmer deleted successfully',
      confirmDeleteFarmer: 'Are you sure you want to delete this farmer',
      errorFetchingFarmers: 'Error fetching farmers',
      errorSavingFarmer: 'Error saving farmer',
      errorDeletingFarmer: 'Error deleting farmer',
      farmerSurveys: 'Farmer Surveys',
      cropsCount: 'Crops Count',
      
      // Participants Management
      participantsManagement: 'Participants Management',
      participantsPageDescription: 'Manage and track all survey participants',
      searchParticipants: 'Search participants by name, civil ID or phone',
      totalDepartments: 'Total Departments',
      errorFetchingParticipants: 'Error fetching participants',
      errorDeletingParticipant: 'Error deleting participant',
      participantDeleted: 'Participant deleted successfully',
      participantSurveys: 'Participant Surveys',
      department: 'Department',
      
      // Common Fields
      // name: 'Name', // Already defined above
      // phone: 'Phone', // Already defined above
      // civilId: 'Civil ID', // Already defined above
      // notes: 'Notes', // Already defined above
      // createdAt: 'Created At',
      // updatedAt: 'Updated At',
      // actions: 'Actions',
      // surveysCount: 'Surveys Count',
      // dateCollected: 'Date Collected',
      // crop: 'Crop', // Already defined above
      // village: 'Village', // Already defined above
      // viewSurveys: 'View Surveys',
      // errorFetchingSurveys: 'Error fetching surveys',
      requiredFieldsMissing: 'Required fields are missing',
      // update: 'Update', // Already defined above
      // close: 'Close', // Already defined above
      pageUnderDevelopment: 'This page is under development and will be available soon',
      
      // Reports Page
      reportsPageDescription: 'View comprehensive reports and analytics for all survey data',
      exportPDF: 'Export as PDF',
      exportExcel: 'Export as Excel',
      print: 'Print',
      period: 'Period',
      allTime: 'All Time',
      thisMonth: 'This Month',
      thisQuarter: 'This Quarter',
      thisYear: 'This Year',
      allGovernorates: 'All Governorates',
      monthlySurveys: 'Monthly Surveys',
      topFarmers: 'Top Farmers',
      rank: 'Rank',
      jan: 'January',
      feb: 'February',
      mar: 'March',
      apr: 'April',
      may: 'May',
      jun: 'June',
      jul: 'July',
      aug: 'August',
      sep: 'September',
      oct: 'October',
      nov: 'November',
      dec: 'December',
      
      // Seed Reports Page
      seedReports: 'Seed Reports',
      seedReportsDescription: 'View and export comprehensive seed survey data with advanced filtering',
      // exportExcel: 'Export to Excel', // Already defined
      // filters: 'Filters', // Already defined
      clearFilters: 'Clear Filters',
      dateFrom: 'From Date',
      dateTo: 'To Date',
      // all: 'All', // Already defined
      // yes: 'Yes', // Already defined
      // no: 'No', // Already defined
      // localSeed: 'Local Seed', // Already defined
      localSeeds: 'Local Seeds',
      // hasPhotos: 'Has Photos', // Already defined
      // search: 'Search', // Already defined
      searchPlaceholder: 'Search by survey number, farmer name, or civil ID...',
      // state: 'State', // Already defined

      // Surveys Page
      surveysPageTitle: 'Surveys Management',
      surveysPageMessage: 'Manage and track all seed collection surveys',
      surveysList: 'Surveys List',
      deleteSurveyTitle: 'Delete Survey',
      deleteSurveyMessage: 'Are you sure you want to delete this survey? This action cannot be undone.',
      confirmDeleteSurvey: 'Are you sure you want to delete this survey?',
      surveyDeletedSuccessfully: 'Survey deleted successfully',
      backToSurveys: 'Back to Surveys',
      surveyDetails: 'Survey Details',
      meters: 'Meters',
      herbariumSample: 'Herbarium Sample',
      
      // App Name and User
      appName: 'Seed Management',
      seedManagement: 'Seed Management System',
      user: 'User',
      administrator: 'Administrator',
      profile: 'Profile',
      
      // Dashboard Stats
      governorates: 'Governorates',
      
      // Disease and Pests
      diseasesAndPests: 'Diseases and Pests',
      disease: 'Disease',
      pest: 'Pest',
      nameArabic: 'Name (Arabic)',
      nameEnglish: 'Name (English)',
      type: 'Type',
      actions: 'Actions',
      addNew: 'Add New',
      // edit: 'Edit', // Already defined above
      // save: 'Save', // Already defined above
      // cancel: 'Cancel', // Already defined above
      // delete: 'Delete', // Already defined above
      confirmDelete: 'Confirm Delete',
      confirmDeleteMessage: 'Are you sure you want to delete this item?',
      addedSuccessfully: 'Added successfully',
      updatedSuccessfully: 'Updated successfully',
      deletedSuccessfully: 'Deleted successfully',
      errorFetchingData: 'Error fetching data',
      errorSaving: 'Error saving data',
      errorDeleting: 'Error deleting data',
      errorExportingReport: 'Error exporting report',
      noDataAvailable: 'No data available',
      pleaseFieldRequired: 'Please fill all required fields',
      
      // Import Surveys
      importSurveys: 'Import Surveys',
      importSurveysDescription: 'Import multiple surveys from Excel file',
      uploadExcel: 'Upload Excel File',
      dragDropFile: 'Drag and drop Excel file here',
      orClickToSelect: 'or click to select file',
      downloadTemplate: 'Download Template',
      importNow: 'Import Now',
      importing: 'Importing...',
      pleaseWait: 'Please wait while we process your file...',
      importResults: 'Import Results',
      totalRows: 'Total Rows',
      imported: 'Imported',
      failed: 'Failed',
      importSuccessMessage: '{{count}} surveys imported successfully',
      errors: 'Errors',
      rowNumber: 'Row Number',
      errorMessage: 'Error Message',
      tryAgain: 'Try Again',
      instructions: 'Instructions',
      instructionStep1: 'Download the Excel template using the button above',
      instructionStep2: 'Fill in the survey data according to the template format',
      instructionStep3: 'Upload the completed Excel file',
      instructionStep4: 'Review the import results and fix any errors if needed',
      note: 'Note',
      requiredFieldsNote: 'Fields marked with * are required. Make sure all required fields are filled correctly.',
      invalidFileType: 'Invalid file type. Please upload an Excel file (.xlsx)',
      noFileSelected: 'Please select a file to import',
      importFailed: 'Import failed. Please check your file and try again.',
      
      // Reference Data
      referenceData: 'Reference Data',
      referenceDataDescription: 'View all reference data including locations, crops, and other codes for Excel import',
      searchReferenceData: 'Search reference data...',
      states: 'States',
      villages: 'Villages',
      statesCount: 'States Count',
      villagesCount: 'Villages Count',
      governorateCode: 'Governorate Code',
      stateCode: 'State Code',
      villageCode: 'Village Code',
      // scientificName: 'Scientific Name', // Already defined above
      // description: 'Description', // Already defined above
      sampleTypes: 'Sample Types',
      total: 'Total',
      referenceDataNote: 'Use these codes when filling the Excel import template. You can search by name or code.',
      copyCode: 'Copy Code',
      copyName: 'Copy Name',
      copied: 'Copied',
      clickToViewStatesAndVillages: 'Click on a governorate to view its states and villages',
      governoratesTree: 'Governorates Tree',
      allStates: 'All States',
      allVillages: 'All Villages',
      crops: 'Crops',
      usages: 'Usages',
      geneticStatuses: 'Genetic Status',
      collectionSources: 'Collection Sources',
      materials: 'Materials',
      topographies: 'Topographies',
      locationStatuses: 'Location Status',
      soilTextures: 'Soil Textures',
      soilColors: 'Soil Colors',
      hardnesses: 'Hardness',
      drainages: 'Drainage',
      soilPHs: 'Soil pH',
      waterPHs: 'Water pH',
      code: 'Code',
      noDataFound: 'No data found',
      availableParticipants: 'Available Participants',
      fillSurveyForm: 'Fill Survey Form',
      progress: 'Progress',
      dateCollected: 'Date Collected',
      selectExistingParticipant: 'Select Existing Participant',
      civilId: 'Civil ID',
      phone: 'Phone',
      PREVIOUS: 'Previous',
      autoLatitude: 'Auto Latitude',
      autoLongitude: 'Auto Longitude',
      latitudeRange: 'Latitude Range',
      longitudeRange: 'Longitude Range',
      soilAndEnvironment: 'Soil and Environment',
      additionalSettings: 'Additional Settings',
      topDiseasesPests: 'Diseases and Pests',
      soilPH: 'Soil pH',
      waterPH: 'Water pH',
      seedOriginLocal: 'Local Seed Origin',
      
      // Participants and Sections
      participants: 'Participants',
      farmerName: 'Farmer Name',
      farmerPhone: 'Farmer Phone',
      section1Participants: 'Section 1 Participants',
      section2Participants: 'Section 2 Participants',
      section1Description: 'Participants from the first directorate section',
      section2Description: 'Participants from the second directorate section',
      
      // Participant Management
      addParticipant: 'Add Participant',
      addResearchDirectorate: '🔬 Add from Agricultural Research',
      addDevelopmentDirectorate: '🌱 Add from Agricultural Development',
      editParticipant: 'Edit Participant',
      deleteParticipant: 'Delete Participant',
      participantName: 'Participant Name',
      participantPhone: 'Participant Phone',
      participantSection: 'Participant Section',
      researchSection: 'General Directorate of Agricultural and Animal Research',
      developmentSection: 'General Directorate of Agricultural Development',
      noParticipants: 'No participants added yet',
      confirmDeleteParticipant: 'Are you sure you want to delete this participant?',
      
      // Additional fields
      collectionAndMaterial: 'Collection and Material Information',
      environmentalConditions: 'Environmental Conditions',
      soilInformation: 'Soil Information',
      settingsInfo: 'Settings',
      collectionSource: 'Collection Source',
      material: 'Material',
      topography: 'Topography',
      locationStatus: 'Location Status',
      soilTexture: 'Soil Texture',
      soilColor: 'Soil Color',
      hardness: 'Hardness',
      drainage: 'Drainage',
      soilPh: 'Soil pH',
      waterPh: 'Water pH',
      isHerbariumSample: 'Is Herbarium Sample',
      hasPhotos: 'Has Photos',
      
      // Participant Management - English
      participantAddedAndSaved: 'Participant added and saved to database successfully',
      civilIdRequired: 'Civil ID is required',
      civilIdAlreadyExists: 'Civil ID already exists',
      errorSavingParticipant: 'Error saving participant',
      selectDepartment: 'Select Department',
      // civilId: 'Civil ID', // Already defined above
      participantNameRequired: 'Participant name is required',
      participantPhoneRequired: 'Participant phone is required',
      participantAdded: 'Participant added successfully',
      participantUpdated: 'Participant updated successfully',
      manageParticipants: 'Manage survey participants',
      participantSingle: 'participant',
      addFirstParticipant: 'Click the button below to add your first participant',
      noPhone: 'No phone number',
      noDepartment: 'No department assigned',
      
      // Enhanced Farmer Selection
      selectFarmer: 'Select Farmer',
      availableFarmers: 'Available Farmers',
      addNewFarmer: 'Add New Farmer',
      searchOrSelectFarmer: 'Search or Select Farmer',
      typeToSearchFarmer: 'Type to search by name, civil ID, or phone',
      selectedFarmer: 'Selected Farmer',
      noFarmersFound: 'No farmers found',
      searchFarmer: 'Search Farmer',
      notProvided: 'Not provided',
      // phone: 'Phone', // Already defined above
    }
  },
  ar: {
    translation: {
      // Navigation
      dashboard: 'لوحة التحكم',
      surveys: 'الاستمارات',
      plants: 'النباتات',
      reports: 'التقارير',
      settings: 'الإعدادات',
      logout: 'تسجيل الخروج',
      createSurvey: 'إنشاء استمارة',
      
      // Authentication
      login: 'تسجيل الدخول',
      username: 'اسم المستخدم',
      password: 'كلمة المرور',
      loginButton: 'دخول',
      loginError: 'اسم المستخدم أو كلمة المرور غير صحيحة',
      
      // Dashboard
      welcomeMessage: 'مرحباً بك في نظام إدارة البذور',
      totalSurveys: 'إجمالي الاستمارات',
      totalParticipants: 'إجمالي المشاركين',
      totalCrops: 'إجمالي المحاصيل',
      recentSurveys: 'الاستمارات الحديثة',
      surveysByGovernorate: 'الاستمارات حسب المحافظة',
      surveysByCrop: 'الاستمارات حسب المحصول',
      noSurveysFound: 'لم يتم العثور على استمارات',
      
      // Survey Form
      surveyForm: 'استمارة المسح',
      step: 'خطوة',
      of: 'من',
      
      // Form sections
      basicInfo: 'المعلومات الأساسية',
      basicInfoAndParticipants: 'المعلومات الأساسية والمشاركون',
      basicInfoAndParticipantsDesc: 'أدخل المعلومات الأساسية للاستمارة وإدارة المشاركون',
      surveyBasicInfoAndParticipants: 'معلومات الاستمارة الأساسية وإدارة المشاركون',
      farmerAndLocation: 'المزارع والموقع',
      farmerAndLocationDesc: 'أدخل تفاصيل المزارع والموقع',
      farmerLocationInfo: 'تفاصيل المزارع والموقع الجغرافي',
      cropSampleAndSettings: 'المحصول والعينة والإعدادات',
      cropSampleAndSettingsDesc: 'أدخل تفاصيل المحصول ومعلومات العينة والإعدادات الإضافية',
      cropSampleSettingsInfo: 'تفاصيل المحصول ومعلومات العينة والإعدادات الإضافية',
      farmerAndParticipants: 'المزارع والمشاركون',
      farmerInfo: 'معلومات المزارع',
      locationInfo: 'معلومات الموقع',
      coordinatesAndDetails: 'الإحداثيات والتفاصيل الإضافية',
      cropInfo: 'معلومات المحصول',
      sampleInfo: 'معلومات العينة',
      coordinates: 'الإحداثيات',
      additionalLocationInfo: 'معلومات إضافية عن الموقع',
      manualLatitude: 'خط العرض اليدوي',
      manualLongitude: 'خط الطول اليدوي',
      elevation: 'الارتفاع',
      elevationPlaceholder: 'أدخل الارتفاع بال متر',
      locationDescription: 'وصف الموقع',
      locationDescriptionPlaceholder: 'اكتب تفاصيل الموقع...',
      cropAge: 'عمر المحصول',
      cropAgePlaceholder: 'مثال: 3 أشهر، سنة واحدة',
      
      // Form fields
      surveyNumber: 'رقم المسح',
      surveyNumberAutoGenerated: 'سيتم توليد رقم المسح تلقائياً',
      participant: 'المشارك',
      farmer: 'المزارع',
      governorate: 'المحافظة',
      state: 'الولاية',
      village: 'القرية',
      latitude: 'خط العرض',
      longitude: 'خط الطول',
      getCurrentLocation: 'الحصول على الموقع الحالي',
      gettingLocation: 'جاري الحصول على الموقع...',
      geolocationNotSupported: 'تحديد الموقع الجغرافي غير مدعوم في هذا المتصفح',
      errorGettingLocation: 'خطأ في الحصول على الموقع. يرجى المحاولة مرة أخرى.',
      crop: 'المحصول',
      usage: 'الاستخدام',
      variety: 'الصنف',
      varietyNumber: 'رقم الصنف',
      localName: 'الاسم المحلي',
      sampleType: 'نوع العينة',
      geneticStatus: 'الحالة الوراثية',
      collectionDate: 'تاريخ الجمع',
      notes: 'ملاحظات',
      hasHerbariumSample: 'يحتوي على عينة عشبية',
      
      // Form validation
      pleaseSelect: 'يرجى الاختيار',
      enterValue: 'أدخل قيمة',
      optional: 'إختياري',
      required: 'مطلوب',
      invalidEmail: 'عنوان البريد الإلكتروني غير صحيح',
      invalidPhone: 'رقم الهاتف غير صحيح',
      invalidDate: 'صيغة التاريخ غير صحيحة',
      
      // Validation messages for survey form
      dateCollectedRequired: 'تاريخ الجمع مطلوب',
      atLeastOneParticipantRequired: 'مشارك واحد على الأقل مطلوب',
      farmerNameRequired: 'اسم المزارع مطلوب',
      farmerPhoneRequired: 'رقم هاتف المزارع مطلوب',
      governorateRequired: 'المحافظة مطلوبة',
      stateRequired: 'الولاية مطلوبة',
      villageRequired: 'القرية مطلوبة',
      
      // Location search texts
      searchOrSelectGovernorate: 'البحث أو اختيار المحافظة',
      searchOrSelectState: 'البحث أو اختيار الولاية', 
      searchOrSelectVillage: 'البحث أو اختيار القرية',
      selectGovernorateFirst: 'يرجى اختيار المحافظة أولاً',
      selectStateFirst: 'يرجى اختيار الولاية أولاً',
      noGovernoratesFound: 'لم يتم العثور على محافظات',
      noStatesFound: 'لم يتم العثور على ولايات',
      noVillagesFound: 'لم يتم العثور على قرى',
      
      // Map Picker translations (new keys only)
      selectLocationFromMap: 'اختيار الموقع من الخريطة',
      clickOnMapToSelectLocation: 'انقر على الخريطة لتحديد الموقع',
      selectedCoordinates: 'الإحداثيات المحددة',
      manualEntry: 'إدخال يدوي',
      mapSelection: 'اختيار من الخريطة',
      searchLocation: 'البحث عن موقع...',
      searching: 'جاري البحث...',
      currentLocation: 'الموقع الحالي',
      zoomIn: 'تكبير',
      zoomOut: 'تصغير',
      
      locationRequired: 'إحداثيات الموقع مطلوبة',
      cropRequired: 'المحصول مطلوب',
      varietyNumberRequired: 'رقم الصنف مطلوب',
      localNameRequired: 'الاسم المحلي مطلوب',
      cropAgeRequired: 'عمر المحصول مطلوب',
      usageRequired: 'استخدام واحد على الأقل مطلوب',
      sampleTypeRequired: 'نوع العينة مطلوب',
      geneticStatusRequired: 'الحالة الوراثية مطلوبة',
      collectionSourceRequired: 'مصدر الجمع مطلوب',
      materialRequired: 'المادة مطلوبة',
      topographyRequired: 'التضاريس مطلوبة',
      locationStatusRequired: 'حالة الموقع مطلوبة',
      soilTextureRequired: 'قوام التربة مطلوب',
      soilColorRequired: 'لون التربة مطلوب',
      hardnessRequired: 'الصلابة مطلوبة',
      drainageRequired: 'التصريف مطلوب',
      soilPhRequired: 'درجة حموضة التربة مطلوبة',
      waterPhRequired: 'درجة حموضة الماء مطلوبة',
      
      // Actions
      next: 'التالي',
      back: 'السابق',
      previous: 'السابق',
      submit: 'إرسال',
      cancel: 'إلغاء',
      save: 'حفظ',
      edit: 'تعديل',
      delete: 'حذف',
      confirm: 'تأكيد',
      view: 'عرض',
      viewDetails: 'عرض التفاصيل',
      search: 'بحث',
      filter: 'فلترة',
      export: 'تصدير',
      add: 'إضافة',
      create: 'إنشاء',
      update: 'تحديث',
      finish: 'إنهاء',
      
      // Common Field Names
      name: 'الاسم',
      surveysCount: 'عدد الاستمارات',
      
      // Status
      loading: 'جاري التحميل...',
      saving: 'جاري الحفظ...',
      success: 'نجح',
      error: 'خطأ',
      warning: 'تحذير',
      info: 'معلومات',
      
      // Messages
      saveSuccess: 'تم حفظ البيانات بنجاح',
      saveError: 'خطأ في حفظ البيانات',
      deleteSuccess: 'تم حذف البيانات بنجاح',
      deleteError: 'خطأ في حذف البيانات',
      loadError: 'خطأ في تحميل البيانات',
      
      // Common
      yes: 'نعم',
      no: 'لا',
      noData: 'لا توجد بيانات',
      selectOption: 'اختر خياراً',
      
      // Survey Details Page Sections
      surveyInformation: 'معلومات الاستمارة',
      locationInformation: 'معلومات الموقع',
      cropInformation: 'معلومات المحصول',
      sampleInformation: 'معلومات العينة',
      topographyInformation: 'معلومات التضاريس',
      photos: 'الصور',
      additionalInformation: 'معلومات إضافية',
      createdBy: 'أنشئت بواسطة',
      createdAt: 'تاريخ الإنشاء',
      
      // Plant List
      plantList: 'قائمة النباتات',
      scientificName: 'الاسم العلمي',
      commonName: 'الاسم الشائع',
      family: 'العائلة',
      
      // Languages
      arabic: 'العربية',
      english: 'English',
      language: 'اللغة',
      
      // Farmers Management
      farmers: 'المزارعون',
      farmersManagement: 'إدارة المزارعين',
      farmersPageTitle: 'إدارة المزارعين',
      farmersPageDescription: 'إدارة وتتبع جميع المزارعين المسجلين في النظام',
      addFarmer: 'إضافة مزارع',
      editFarmer: 'تعديل مزارع',
      deleteFarmer: 'حذف مزارع',
      farmerDetails: 'تفاصيل المزارع',
      totalFarmers: 'إجمالي المزارعين',
      searchFarmers: 'البحث عن المزارعين بالاسم أو الرقم المدني أو الهاتف',
      farmerAddedSuccessfully: 'تم إضافة المزارع بنجاح',
      farmerUpdatedSuccessfully: 'تم تحديث المزارع بنجاح',
      farmerDeletedSuccessfully: 'تم حذف المزارع بنجاح',
      confirmDeleteFarmer: 'هل أنت متأكد من حذف هذا المزارع',
      errorFetchingFarmers: 'خطأ في جلب المزارعين',
      errorSavingFarmer: 'خطأ في حفظ المزارع',
      errorDeletingFarmer: 'خطأ في حذف المزارع',
      farmerSurveys: 'استمارات المزارع',
      cropsCount: 'عدد المحاصيل',
      
      // Participants Management
      participantsManagement: 'إدارة المشاركين',
      participantsPageDescription: 'إدارة وتتبع جميع المشاركين في الاستمارات',
      searchParticipants: 'البحث عن المشاركين بالاسم أو الرقم المدني أو الهاتف',
      totalDepartments: 'إجمالي الأقسام',
      errorFetchingParticipants: 'خطأ في جلب المشاركين',
      errorDeletingParticipant: 'خطأ في حذف المشارك',
      participantDeleted: 'تم حذف المشارك بنجاح',
      participantSurveys: 'استمارات المشارك',
      department: 'القسم',
      
      // Common Fields
      // name: 'الاسم', // Already defined
      // phone: 'الهاتف', // Already defined
      // civilId: 'الرقم المدني', // Already defined
      // notes: 'ملاحظات', // Already defined
      // createdAt: 'تاريخ الإنشاء',
      // updatedAt: 'تاريخ التحديث',
      // actions: 'الإجراءات',
      // surveysCount: 'عدد الاستمارات',
      // dateCollected: 'تاريخ الجمع',
      // crop: 'المحصول', // Already defined
      // village: 'القرية', // Already defined
      // viewSurveys: 'عرض الاستمارات',
      // errorFetchingSurveys: 'خطأ في جلب الاستمارات',
      requiredFieldsMissing: 'الحقول المطلوبة مفقودة',
      // update: 'تحديث', // Already defined
      // close: 'إغلاق', // Already defined
      pageUnderDevelopment: 'هذه الصفحة قيد التطوير وستكون متاحة قريباً',
      
      // Reports Page
      reportsPageDescription: 'عرض التقارير والتحليلات الشاملة لجميع بيانات الاستمارات',
      exportPDF: 'تصدير كـ PDF',
      exportExcel: 'تصدير كـ Excel',
      print: 'طباعة',
      period: 'الفترة',
      allTime: 'جميع الأوقات',
      thisMonth: 'هذا الشهر',
      thisQuarter: 'هذا الربع',
      thisYear: 'هذه السنة',
      allGovernorates: 'جميع المحافظات',
      monthlySurveys: 'الاستمارات الشهرية',
      topFarmers: 'أفضل المزارعين',
      rank: 'الترتيب',
      jan: 'يناير',
      feb: 'فبراير',
      mar: 'مارس',
      apr: 'أبريل',
      may: 'مايو',
      jun: 'يونيو',
      jul: 'يوليو',
      aug: 'أغسطس',
      sep: 'سبتمبر',
      oct: 'أكتوبر',
      nov: 'نوفمبر',
      dec: 'ديسمبر',
      
      // Seed Reports Page
      seedReports: 'تقارير البذور',
      seedReportsDescription: 'عرض وتصدير بيانات استمارات البذور الشاملة مع فلترة متقدمة',
      clearFilters: 'مسح الفلاتر',
      dateFrom: 'من تاريخ',
      dateTo: 'إلى تاريخ',
      localSeeds: 'البذور المحلية',
      searchPlaceholder: 'البحث برقم الاستمارة، اسم المزارع، أو الرقم المدني...',

      // Surveys Page
      surveysPageTitle: 'إدارة الاستمارات',
      surveysPageMessage: 'إدارة وعرض جميع الاستمارات المجمعة.',
      surveysList: 'قائمة الاستمارات',
      deleteSurveyTitle: 'تأكيد الحذف',
      deleteSurveyMessage: 'هل أنت متأكد أنك تريد حذف هذه الاستمارة؟ لا يمكن التراجع عن هذا الإجراء.',
      confirmDeleteSurvey: 'هل أنت متأكد من حذف هذه الاستمارة؟',
      surveyDeletedSuccessfully: 'تم حذف الاستمارة بنجاح',
      surveyDetails: 'تفاصيل الاستمارة',
      backToSurveys: 'العودة إلى الاستمارات',
      meters: 'متر',
      herbariumSample: 'عينة هيرباريوم',
      
      // App Name and User
      appName: 'نظام إدارة البذور',
      seedManagement: 'نظام إدارة البذور',
      user: 'المستخدم',
      administrator: 'المشرف',
      profile: 'الملف الشخصي',
      
      // Dashboard Stats
      governorates: 'المحافظات',
      
      // Disease and Pests
      diseasesAndPests: 'الأمراض والآفات',
      disease: 'مرض',
      pest: 'آفة',
      nameArabic: 'الاسم بالعربية',
      nameEnglish: 'الاسم بالإنجليزية',
      type: 'النوع',
      actions: 'الإجراءات',
      addNew: 'إضافة جديد',
      // edit: 'تعديل', // Already defined above
      // save: 'حفظ', // Already defined above
      // cancel: 'إلغاء', // Already defined above
      // delete: 'حذف', // Already defined above
      confirmDelete: 'تأكيد الحذف',
      confirmDeleteMessage: 'هل أنت متأكد من حذف هذا العنصر؟',
      addedSuccessfully: 'تمت الإضافة بنجاح',
      updatedSuccessfully: 'تم التحديث بنجاح',
      deletedSuccessfully: 'تم الحذف بنجاح',
      errorFetchingData: 'خطأ في جلب البيانات',
      errorSaving: 'خطأ في حفظ البيانات',
      errorDeleting: 'خطأ في حذف البيانات',
      errorExportingReport: 'خطأ في تصدير التقرير',
      noDataAvailable: 'لا توجد بيانات متاحة',
      pleaseFieldRequired: 'الرجاء ملء جميع الحقول المطلوبة',
      
      // Import Surveys
      importSurveys: 'استيراد الاستمارات',
      importSurveysDescription: 'استيراد استمارات متعددة من ملف Excel',
      uploadExcel: 'رفع ملف Excel',
      dragDropFile: 'اسحب وأفلت ملف Excel هنا',
      orClickToSelect: 'أو انقر لاختيار الملف',
      downloadTemplate: 'تحميل النموذج',
      importNow: 'استيراد الآن',
      importing: 'جاري الاستيراد...',
      pleaseWait: 'الرجاء الانتظار أثناء معالجة الملف...',
      importResults: 'نتائج الاستيراد',
      totalRows: 'إجمالي الصفوف',
      imported: 'تم استيرادها',
      failed: 'فشل',
      importSuccessMessage: 'تم استيراد {{count}} استمارة بنجاح',
      errors: 'الأخطاء',
      rowNumber: 'رقم الصف',
      errorMessage: 'رسالة الخطأ',
      tryAgain: 'حاول مرة أخرى',
      instructions: 'التعليمات',
      instructionStep1: 'قم بتحميل نموذج Excel باستخدام الزر أعلاه',
      instructionStep2: 'املأ بيانات الاستمارات وفقًا لتنسيق النموذج',
      instructionStep3: 'قم برفع ملف Excel المكتمل',
      instructionStep4: 'راجع نتائج الاستيراد وقم بإصلاح أي أخطاء إذا لزم الأمر',
      note: 'ملاحظة',
      requiredFieldsNote: 'الحقول المميزة بـ * مطلوبة. تأكد من ملء جميع الحقول المطلوبة بشكل صحيح.',
      invalidFileType: 'نوع ملف غير صالح. الرجاء رفع ملف Excel (.xlsx)',
      noFileSelected: 'الرجاء اختيار ملف للاستيراد',
      importFailed: 'فشل الاستيراد. الرجاء التحقق من الملف والمحاولة مرة أخرى.',
      
      // Reference Data
      referenceData: 'البيانات المرجعية',
      referenceDataDescription: 'عرض جميع البيانات المرجعية بما في ذلك المواقع والمحاصيل والرموز الأخرى لاستيراد Excel',
      searchReferenceData: 'البحث في البيانات المرجعية...',
      states: 'الولايات',
      villages: 'القرى',
      statesCount: 'عدد الولايات',
      villagesCount: 'عدد القرى',
      governorateCode: 'رمز المحافظة',
      stateCode: 'رمز الولاية',
      villageCode: 'رمز القرية',
      // scientificName: 'الاسم العلمي', // Already defined above
      // description: 'الوصف', // Already defined above
      sampleTypes: 'أنواع العينات',
      total: 'المجموع',
      referenceDataNote: 'استخدم هذه الرموز عند ملء نموذج استيراد Excel. يمكنك البحث بالاسم أو الرمز.',
      copyCode: 'نسخ الرمز',
      copyName: 'نسخ الاسم',
      copied: 'تم النسخ',
      clickToViewStatesAndVillages: 'انقر على المحافظة لعرض ولاياتها وقراها',
      governoratesTree: 'شجرة المحافظات',
      allStates: 'جميع الولايات',
      allVillages: 'جميع القرى',
      crops: 'المحاصيل',
      usages: 'الاستخدامات',
      geneticStatuses: 'الوضع الجيني',
      collectionSources: 'مصادر الجمع',
      materials: 'المواد',
      topographies: 'الطوبوغرافيا',
      locationStatuses: 'حالة الموقع',
      soilTextures: 'قوام التربة',
      soilColors: 'ألوان التربة',
      hardnesses: 'الصلابة',
      drainages: 'التصريف',
      soilPHs: 'قياس التربة PH',
      waterPHs: 'قياس الماء PH',
      code: 'الرمز',
      noDataFound: 'لا توجد بيانات',
      availableParticipants: 'المشاركين المتوفرين',
      fillSurveyForm: 'تعبئة استمارة المسح',
      progress: 'التقدم',
      dateCollected: 'تاريخ الجمع',
      selectExistingParticipant: 'اختيار مشارك موجود',
      civilId: 'الرقم المدني',
      phone: 'الهاتف',
      PREVIOUS: 'السابق',
      autoLatitude: 'خط العرض التلقائي',
      autoLongitude: 'خط الطول التلقائي',
      latitudeRange: 'نطاق خط العرض',
      longitudeRange: 'نطاق خط الطول',
      soilAndEnvironment: 'التربة والبيئة',
      additionalSettings: 'الإعدادات الإضافية',
      topDiseasesPests: 'الأمراض والآفات',
      soilPH: 'قياس التربة pH',
      waterPH: 'قياس الماء pH',
      seedOriginLocal: 'أصل البذور المحلية',
      
      // Participants and Sections
      participants: 'المشاركون',
      farmerName: 'اسم المزارع',
      farmerPhone: 'رقم هاتف المزارع',
      section1Participants: 'المشاركون من القسم الأول',
      section2Participants: 'المشاركون من القسم الثاني',
      section1Description: 'المشاركون من قسم المديرية الأولى',
      section2Description: 'المشاركون من قسم المديرية الثانية',
      
      // Participant Management
      addParticipant: 'إضافة مشارك',
      addResearchDirectorate: '🔬 إضافة من البحوث الزراعية',
      addDevelopmentDirectorate: '🌱 إضافة من التنمية الزراعية',
      editParticipant: 'تعديل مشارك',
      deleteParticipant: 'حذف مشارك',
      participantName: 'اسم المشارك',
      participantPhone: 'رقم هاتف المشارك',
      participantSection: 'قسم المشارك',
      researchSection: 'المديرية العامة للبحوث الزراعية والحيوانية',
      developmentSection: 'المديرية العامة للتنمية الزراعية',
      noParticipants: 'لم يتم إضافة مشاركين بعد',
      confirmDeleteParticipant: 'هل أنت متأكد من حذف هذا المشارك؟',
      participantNameRequired: 'اسم المشارك مطلوب',
      participantPhoneRequired: 'رقم هاتف المشارك مطلوب',
      participantSectionRequired: 'قسم المشارك مطلوب',
      participantAdded: 'تم إضافة المشارك بنجاح',
      participantUpdated: 'تم تحديث المشارك بنجاح',
      // participantDeleted: 'تم حذف المشارك بنجاح',
      participantAddedAndSaved: 'تم إضافة المشارك وحفظه في قاعدة البيانات بنجاح',
      civilIdRequired: 'الرقم المدني مطلوب',
      civilIdAlreadyExists: 'الرقم المدني موجود مسبقاً',
      errorSavingParticipant: 'خطأ في حفظ المشارك',
      selectDepartment: 'اختر القسم',
      // civilId: 'الرقم المدني', // Already defined
      manageParticipants: 'إدارة مشاركي الاستمارة',
      participantSingle: 'مشارك',
      addFirstParticipant: 'انقر على الزر أدناه لإضافة أول مشارك',
      noPhone: 'لا يوجد رقم هاتف',
      noDepartment: 'لا يوجد قسم محدد',
      
      // Enhanced Farmer Selection
      selectFarmer: 'اختيار المزارع',
      availableFarmers: 'المزارعين المتوفرين',
      addNewFarmer: 'إضافة مزارع جديد',
      searchOrSelectFarmer: 'البحث أو اختيار المزارع',
      typeToSearchFarmer: 'اكتب للبحث بالاسم أو الرقم المدني أو الهاتف',
      selectedFarmer: 'المزارع المحدد',
      noFarmersFound: 'لم يتم العثور على مزارعين',
      searchFarmer: 'البحث عن مزارع',
      notProvided: 'غير محدد',
      // phone: 'الهاتف', // Already defined
      
      // Additional fields
      collectionAndMaterial: 'معلومات الجمع والمادة',
      environmentalConditions: 'الظروف البيئية',
      soilInformation: 'معلومات التربة',
      settingsInfo: 'الإعدادات',
      collectionSource: 'مصدر الجمع',
      material: 'المادة',
      topography: 'الجغرافيا',
      locationStatus: 'حالة الموقع',
      soilTexture: 'نسيج التربة',
      soilColor: 'لون التربة',
      hardness: 'الصلابة',
      drainage: 'التصريف',
      soilPh: 'رقم الهيدروجين في التربة',
      waterPh: 'رقم الهيدروجين في الماء',
      isHerbariumSample: 'هل هي عينة هيرباريوم؟',
      hasPhotos: 'هل هناك صور؟',
    }
  }
};

// Function to get saved language from localStorage
const getSavedLanguage = (): string => {
  const savedLang = localStorage.getItem('language');
  return savedLang || 'ar'; // default to Arabic if no saved language
};

// Function to save language to localStorage
export const saveLanguage = (language: string): void => {
  localStorage.setItem('language', language);
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: getSavedLanguage(), // use saved language or default
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

// Set initial document direction
const initialLang = getSavedLanguage();
document.dir = initialLang === 'ar' ? 'rtl' : 'ltr';

// Save language whenever it changes
i18n.on('languageChanged', (lng: string) => {
  saveLanguage(lng);
  // Update document direction
  document.dir = lng === 'ar' ? 'rtl' : 'ltr';
});

// Function to determine text direction
export const dir = (language: string): 'ltr' | 'rtl' => {
  return language === 'ar' ? 'rtl' : 'ltr';
};

export default i18n;
